<template>
  <div id="app">
    <transition mode="out-in">
      <router-view />
    </transition>
  </div>
</template>

<script>
export default {
  created() {
    this.$store.commit(
      "switchLang",
      this.$route.path.split("/")[1] === "en" ? "en" : "ja"
    );
    this.$route.path.split("/")[1] === "en" &&
      document.getElementById("hitobo-custom-trigger").classList.add("none");
    const description =
      this.$route.path.split("/")[1] === "en"
        ? "TMF VIRTUAL RUN is a portal introducing virtual running events organized by the Tokyo Marathon Foundation. Participants can participate in the various events by utilizing a running app with GPS tracking."
        : "東京マラソン財団が運営するバーチャルランのエントリー＆ランキングサイトです。GPS連動のランニングアプリを使って各イベントにご参加いただけます。";
    document
      .querySelector("meta[name='description']")
      .setAttribute("content", description);
  },
  name: "App",
};
</script>

<style>
@import "assets/styles/color.css";
@import "assets/styles/common.scss";
@import "assets/styles/setting.scss";
#app {
  font-family: "Lato", "游ゴシック", YuGothic, "ヒラギノ角ゴ ProN W3",
    "Hiragino Kaku Gothic ProN", "メイリオ", Meiryo, sans-serif;
  color: #000;
  @media all and (-ms-high-contrast: none) {
    font-family: "メイリオ", Meiryo, sans-serif;
  }
}
/*遷移する際のフワッと演出*/
.v-enter-active,
.v-leave-active {
  transition: opacity 0.4s;
}
.v-enter,
.v-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue